<template>
  <div>
    <template v-if="recordStampData === null">
      <div class="text-center">
        <loading-in-progress />
      </div>
    </template>
    <template v-else>
      <div style="height: 30px">
        <slot name="header">
          <h2>{{ title | capitalize }}</h2>
        </slot>
      </div>
      <v-row>
        <v-col cols="6">
          <table>
            <tbody>
              <tr>
                <td class="pa-2">{{ $t("creationDate") | capitalize }}</td>
                <td>{{ recordStampData.createdAt | formatDateTimeSeconds }}</td>
              </tr>
              <tr>
                <td class="pa-2">{{ $t("by") | capitalize }}</td>
                <td>{{ recordStampData.userName }}</td>
              </tr>
              <tr>
                <td class="pa-2">{{ $t("details") | capitalize }}</td>
                <td>{{ recordStampData.description }}</td>
              </tr>
            </tbody>
          </table>
        </v-col>
        <v-col v-show="hasSlotData" cols><slot></slot></v-col>
      </v-row>
      <h3 class="mt-3">{{ $t("modifications") | capitalize }}</h3>
      <v-simple-table :dense="recordStampData.recordStampModifications.length > 5" height="600" fixed-header>
        <template #default>
          <thead>
            <tr>
              <th style="text-align: center">{{ $t("date") | capitalize }}</th>
              <th style="text-align: center">{{ $t("by") | capitalize }}</th>
              <th style="text-align: left">{{ $t("details") | capitalize }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(modificationItem, index) in recordStampData.recordStampModifications" :key="index">
              <td style="text-align: center">
                {{ modificationItem.modifyAt | formatDateTimeSeconds }}
              </td>
              <td style="text-align: center">
                {{ modificationItem.userName }}
              </td>
              <td style="text-align: left">
                <span v-html="modificationItem.description"></span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import CustomDialog from "@/components/shared/layout/CustomDialog.vue";
import { getRecordStamp } from "@/requests/recordStamp";
import GetRecordStampResponse from "@/models/api/recordStamp/GetRecordStampResponse";
import LoadingInProgress from "@/components/shared/LoadingInProgress.vue";
import _ from "lodash";
import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";
@Component({
  components: { LoadingInProgress, CustomDialog },
})
export default class RecordStampDialog extends Vue {
  @PropSync("recordStampId", { required: true })
  _recordStampId!: number | null;

  @Prop({ required: false, default: filterCapitalize(i18n.t("recordData")) })
  title!: string;

  recordStampData: GetRecordStampResponse | null = null;

  @Watch("_recordStampId")
  async downloadRecordStamp(val: number | null): Promise<void> {
    if (val !== null) {
      this.recordStampData = null;
      this.recordStampData = await getRecordStamp(this._recordStampId as number);
      this.recordStampData.recordStampModifications = _.orderBy(
        this.recordStampData.recordStampModifications,
        "modifyAt",
        "desc"
      );
    } else {
      this.recordStampData = null;
    }
  }

  hasSlotData(): boolean {
    return !!this.$slots.default;
  }
}
</script>
